import React, { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import alpoder from "../../../assets/img/home/logo_actividad.png";
import "./Home.scss";


const Home: FunctionComponent<{ props?: any }> = (props) => (
  <div className="homeContainer">
    <div className="homeContainer-content">
      <div className="homeContainer-content section">
        <p className="mediumBold">¡Nada es imposible <br />
          <span className="mediumBold-pink">si lo hacemos juntas!</span></p>
        <img src={alpoder} className="logoAlPoder" />
        <div className="sectionBottom">
          <p className="boldRegular">
            Usa tu <span className="boldRegular-pink">rayo de Loving</span> para derribar todas esas palabras <br />
            que nos hacen sentir inseguras.
          </p>
          <Link to="/game" className="btnjuega" >
            Juega
          </Link>
        </div>
      </div>
    </div>
  </div>
)
export default Home;